// The drag affordance shown in Customize mode in place of a panel/tile's
// category icon (Figma 6348:133579). Purely visual — the whole card is the drag
// source (see use-drag-reorder usage), so this just signals "draggable". Sizes
// its own 12px glyph to slot into the host icon position.
import { DotsGrid } from './icons'

export const DragGrip = () => (
	<span
		aria-hidden="true"
		className="cg-grip-in inline-flex items-center justify-center text-[rgb(var(--cg-text-tertiary))] [&>svg]:h-3 [&>svg]:w-3"
	>
		<DotsGrid />
	</span>
)
